import { Model } from '@vuex-orm/core'
import { Constants } from '@/constants'

export default class Message extends Model {
    static entity = 'dashboard'

    static fields() {
        return {
            id: this.attr(null)
        }
    }

    static async summary() {
        return await this.api().get(Constants.API.DASHBOARD + '/summary')
    }

    static apiConfig = {
        actions: {
            fetch: {
                method: 'get',
                url: '/dashboard'
            }
        }
    }
}
